import { useQuery } from "@tanstack/react-query";
import { invariant } from "@searchui-searchforms/shared/utils";
import { getPersonSuggestions } from "./getPersonSuggestions";

export const usePersonSuggestionsQuery = (options: {
    treeId: string | undefined;
    givenName: string;
    surname: string;
}) => {
    const { treeId, givenName, surname } = options;
    const queryEnabled = treeId && (givenName.length || surname.length);

    return useQuery({
        queryKey: ["personSuggestions", { givenName, surname, treeId }],
        enabled: !!queryEnabled,
        queryFn: () => {
            invariant(treeId, "treeId is required");
            return getPersonSuggestions({
                partialFirstName: givenName,
                partialLastName: surname,
                treeId,
            });
        },
    });
};
